export default (theme) => ({
  modal: {
    overflow: 'hidden',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1200,
    maxHeight: '90vh',
    minHeight: '90vh',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 1001,
    background: theme.palette.background.white,
    borderRadius: 33,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      height: '100%',
      borderRadius: 0,
    },
  },
  smallSizeModal: {
    minHeight: '10vh',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  overlay: {
    width: '100%',
    height: '100%',
    background: theme.palette.disabled.main,
    opacity: 0.7,
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1001,
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15,
    padding: 0,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    '& svg': {
      transition: 'fill .2s linear',
      '&:hover': {
        fill: theme.palette.primary.main,
      },
    },
  },
});
